import React from 'react';
import { Button as UniversalButton, ButtonProps as UniversalButtonProps, GestureResponderEvent } from '@myddusfvs/ui-universal';

interface ButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
  isLoading?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement> | GestureResponderEvent) => void; // Map to onPress correctly
}

/**
 * Button Component - Universal Migration Wrapper
 * Wraps @myddusfvs/ui-universal/Button to maintain TailWind compatibility while leveraging 
 * cross-platform building blocks.
 */
const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  isLoading = false,
  className = '',
  disabled,
  onClick,
}) => {
  // Map variant to ensure type safety
  const safeVariant: UniversalButtonProps['variant'] =
    variant === 'primary' || variant === 'secondary' || variant === 'danger' || variant === 'ghost'
      ? variant
      : 'primary';

  return (
    <div className={className}>
      <UniversalButton
        variant={safeVariant}
        isLoading={isLoading}
        disabled={disabled}
        onPress={onClick}
      >
        {children}
      </UniversalButton>
    </div>
  );
};

export default Button;
